<template>
    <div>
         <div class="row justify-content-center">
          <div class="col-md-7" 
            :style="`background-image:url('${$store.state.data.undangan.gambar4}')`"
          style="background:#100001;position:relative;
          background-size:cover;background-repeat:no-repeat;background-position: center center;">
            <!-- <img src="@/static/draw1.jpeg" style="height:130vh;width:100%;position:absolute;right:0;top:0;z-index:10;" alt=""> -->
            <!-- <div  style="height:100%;width:100%;position:absolute;z-index:10000;" id="particlesjs4" ></div> -->
            <br>
            <br>
            <br>
            <div style="height:100px;"></div>
            <p class=" text-3xl sm:text-5xl font-semibold text-center" style="letter-spacing: 4px;word-spacing: 4px;font-family: 'Alex Brush', cursive;">
                
            </p>
            <div class="p-1">
                <div class="bg-white p-1 rounded-lg wow ml-1 sm:ml-0"
                :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                 style="border:3px solid yellow;">
                   <iframe style="width:100%;" height="315" src="https://www.youtube.com/embed/h3PQlvXvKlQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
           <br>
            <br>
            <br>
          </div>
        </div>
    </div>
</template>
<script>
import 'particles.js'
import axios from "axios";
export default {
  data() {
    return {
     
    };
  },
  props:['particle'],
  mounted() {
        // window.particlesJS("particlesjs4", this.$store.state.particle)
  },
  components: {
  },
  methods: {
    
  },
};
</script>